"use strict";

var _regeneratorRuntime = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/helpers/asyncToGenerator");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

var remote_groups_1 = __importDefault(require("../constants/actions/remote-groups"));

var api_1 = __importDefault(require("../api"));

var my_error_1 = __importDefault(require("../models/my-error"));

var RemoteGroupsCache = __importStar(require("../utils/cache/remote-groups"));

var _unhookMap = {};

function _unhook(groupId) {
  var unsubscribe = _unhookMap[groupId];

  if (unsubscribe) {
    unsubscribe();
    delete _unhookMap[groupId];
  }
}

function init() {
  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(dispatch, getState) {
        var list;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch({
                  type: remote_groups_1.default.GET_LIST_INIT
                });
                _context.prev = 1;
                _context.next = 4;
                return api_1.default.Groups.fetchMyGroups();

              case 4:
                list = _context.sent;
                RemoteGroupsCache.updateList(list);
                dispatch({
                  type: remote_groups_1.default.GET_LIST_SUCCESS,
                  list: list
                });
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);
                dispatch({
                  type: remote_groups_1.default.GET_LIST_FAILURE,
                  error: _context.t0
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 9]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}

exports.init = init;

function reload() {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(dispatch, getState) {
        var list;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dispatch({
                  type: remote_groups_1.default.RELOAD_INIT
                });
                _context2.prev = 1;
                _context2.next = 4;
                return api_1.default.Groups.fetchMyGroups();

              case 4:
                list = _context2.sent;
                RemoteGroupsCache.updateList(list);
                dispatch({
                  type: remote_groups_1.default.RELOAD_SUCCESS,
                  list: list
                });
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](1);
                dispatch({
                  type: remote_groups_1.default.RELOAD_FAILURE,
                  error: _context2.t0
                });

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 9]]);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}

exports.reload = reload;

function add(data) {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(dispatch, getState) {
        var group;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dispatch({
                  type: remote_groups_1.default.ADD_INIT
                });
                _context3.prev = 1;
                _context3.next = 4;
                return api_1.default.Groups.add(data);

              case 4:
                group = _context3.sent;
                RemoteGroupsCache.updateOne(group);
                dispatch({
                  type: remote_groups_1.default.ADD_SUCCESS,
                  group_data: group
                });
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](1);
                dispatch({
                  type: remote_groups_1.default.ADD_FAILURE,
                  error: _context3.t0
                });

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 9]]);
      }));

      return function (_x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
}

exports.add = add;

function remove(groupId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(dispatch, getState) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dispatch({
                  type: remote_groups_1.default.REMOVE_INIT
                });
                _context4.prev = 1;
                _context4.next = 4;
                return api_1.default.Groups.remove(groupId);

              case 4:
                dispatch({
                  type: remote_groups_1.default.REMOVE_SUCCESS,
                  group_id: groupId
                });
                _context4.next = 10;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](1);
                dispatch({
                  type: remote_groups_1.default.REMOVE_FAILURE,
                  error: _context4.t0
                });

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[1, 7]]);
      }));

      return function (_x7, _x8) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
}

exports.remove = remove;

function edit(groupId, editProps) {
  return (
    /*#__PURE__*/
    function () {
      var _ref5 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(dispatch, getState) {
        var list, curGroup, groupData;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                dispatch({
                  type: remote_groups_1.default.EDIT_INIT
                });
                _context5.prev = 1;
                list = getState().remoteGroups.list;
                curGroup = lodash_1.default.find(list, {
                  id: groupId
                });

                if (!(curGroup === undefined)) {
                  _context5.next = 6;
                  break;
                }

                throw new my_error_1.default('Database not found');

              case 6:
                _context5.next = 8;
                return api_1.default.Groups.edit(groupId, editProps);

              case 8:
                groupData = _context5.sent;
                RemoteGroupsCache.updateOne(groupData);
                dispatch({
                  type: remote_groups_1.default.EDIT_SUCCESS,
                  group_id: groupId,
                  group_data: groupData
                });
                _context5.next = 16;
                break;

              case 13:
                _context5.prev = 13;
                _context5.t0 = _context5["catch"](1);
                dispatch({
                  type: remote_groups_1.default.EDIT_FAILURE,
                  error: _context5.t0
                });

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[1, 13]]);
      }));

      return function (_x9, _x10) {
        return _ref5.apply(this, arguments);
      };
    }()
  );
}

exports.edit = edit;

function hook(groupId) {
  return function (dispatch, getState) {
    _unhook(groupId);

    var _unsubscribeGroup = api_1.default.Groups.getRef(groupId).onSnapshot(function (snap) {
      var data = null;

      if (snap.exists) {
        data = Object.assign({}, snap.data(), {
          id: snap.id
        });
        RemoteGroupsCache.updateOne(data);
      } else {
        RemoteGroupsCache.removeById(groupId);
      }

      dispatch({
        type: remote_groups_1.default.ON_GROUP_UPDATE,
        data: data,
        group_id: groupId
      });
    });

    _unhookMap[groupId] = _unsubscribeGroup;
  };
}

exports.hook = hook;

function unhook(groupId) {
  return function (dispatch, getState) {
    _unhook(groupId);
  };
}

exports.unhook = unhook;

function resetMyGroupNewPendingItemsCounter(groupId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref6 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(dispatch, getState) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                dispatch({
                  type: remote_groups_1.default.RESET_NEW_PENDING_ITEMS_COUNTER_INIT
                });
                _context6.prev = 1;
                _context6.next = 4;
                return api_1.default.Groups.resetNewPendingItemsCounter(groupId);

              case 4:
                dispatch({
                  type: remote_groups_1.default.RESET_NEW_PENDING_ITEMS_COUNTER_SUCCESS,
                  group_id: groupId
                });
                _context6.next = 10;
                break;

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](1);
                dispatch({
                  type: remote_groups_1.default.RESET_NEW_PENDING_ITEMS_COUNTER_FAILURE,
                  error: _context6.t0
                });

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[1, 7]]);
      }));

      return function (_x11, _x12) {
        return _ref6.apply(this, arguments);
      };
    }()
  );
}

exports.resetMyGroupNewPendingItemsCounter = resetMyGroupNewPendingItemsCounter;